import * as Yup from "yup";

export const dataModel = {
  codeUuid: "",
  initTime: "",
  endTime: "",
  numPlants: "",
  rows: [],
  taskUuid: "",
  comments: "",

  dailyDate: "",
  userUuid: "",
  // status: "",
  // isNight: "",
  // viveroUuid: "",
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      codeUuid: Yup.string().required("forms.validations.required"),
      initTime: Yup.date().required("forms.validations.required"),
      endTime: Yup.date()
        .required("forms.validations.required")
        .min(Yup.ref("initTime"), "forms.validations.timeGreaterThan"),
      numPlants: Yup.number().required("forms.validations.required"),
      rows: Yup.array().optional("forms.validations.required"),
      taskUuid: Yup.string().required("forms.validations.required"),
      comments: Yup.string().optional(""),

      dailyDate: Yup.date().required("forms.validations.required"),
      userUuid: Yup.string().required("forms.validations.required"),
      // status: Yup.string().required("forms.validations.required"),
      // isNight: Yup.boolean().required("forms.validations.required"),
      // viveroUuid: Yup.string().required("forms.validations.required"),
    });
  }

  return Yup.object().shape({
    codeUuid: Yup.string().required("forms.validations.required"),
    initTime: Yup.date().required("forms.validations.required"),
    endTime: Yup.date()
      .required("forms.validations.required")
      .min(Yup.ref("initTime"), "forms.validations.timeGreaterThan"),
    numPlants: Yup.number().required("forms.validations.required"),
    rows: Yup.array().optional("forms.validations.required"),
    taskUuid: Yup.string().required("forms.validations.required"),
    comments: Yup.string().optional(""),

    dailyDate: Yup.date().required("forms.validations.required"),
    userUuid: Yup.string().required("forms.validations.required"),
    // status: Yup.string().required("forms.validations.required"),
    // isNight: Yup.boolean().required("forms.validations.required"),
    // viveroUuid: Yup.string().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
